import { TemplateRef } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomerService } from '../../../services/customer.service';
import { TranslateService } from '@ngx-translate/core';
var DocumentApprovalPreviewComponent = (function () {
    function DocumentApprovalPreviewComponent(activatedRoute, customerApiService, formBuilder, modalService, translate) {
        this.activatedRoute = activatedRoute;
        this.customerApiService = customerApiService;
        this.formBuilder = formBuilder;
        this.modalService = modalService;
        this.translate = translate;
        this.isLoading = true;
        this.confirmLoading = false;
        this.errorMsg = '';
        this.showSubmissionComplete = false;
        this.language = localStorage.getItem('lang') || 'en';
        this.pdfPage = 1;
        this.pdfLoaded = false;
    }
    DocumentApprovalPreviewComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.activatedRoute.queryParams.subscribe(function (params) {
            _this.document = params.code;
            if (_this.document) {
                _this.getTaxData();
            }
        });
    };
    DocumentApprovalPreviewComponent.prototype.closeModal = function () {
        if (this.modal) {
            this.modal.close();
        }
        this.confirmLoading = false;
    };
    DocumentApprovalPreviewComponent.prototype.getErrorMessage = function (error) {
        this.errorMsg = '';
        this.errorMsg = error.error.detail ? error.error.detail : 'There was an error while loading data. Please contact the administrator';
        this.closeModal();
    };
    DocumentApprovalPreviewComponent.prototype.submissionCompleted = function () {
        this.confirmLoading = false;
        this.showSubmissionComplete = true;
        this.closeModal();
    };
    DocumentApprovalPreviewComponent.prototype.back = function () {
        this.errorMsg = '';
    };
    DocumentApprovalPreviewComponent.prototype.changeLanguage = function (lang) {
        if (lang === 'en') {
            this.translate.use('en');
            localStorage.setItem('lang', 'en');
        }
        else if (lang === 'th') {
            this.translate.use('th');
            localStorage.setItem('lang', 'th');
        }
    };
    DocumentApprovalPreviewComponent.prototype.confirm = function () {
        var _this = this;
        this.confirmLoading = true;
        if (this.action === 'approve') {
            this.customerApiService.approveTaxData(this.document).subscribe(function (result) {
                _this.submissionCompleted();
            }, function (error) {
                _this.confirmLoading = false;
                _this.getErrorMessage(error);
            });
        }
        else if (this.action === 'reject') {
            var data = this.customerForm.getRawValue();
            this.customerApiService.rejectTaxData(this.document, {
                contact: data.contact,
                remark: data.remark,
                suggestion: {
                    address: data.address,
                    branch_code: data.branchCode,
                    email: data.email,
                    cc_email: data.ccEmail,
                    country_code: data.countryCode,
                    name: data.name,
                    post_code: data.postCode,
                    tax_id: data.tax_id,
                }
            }).subscribe(function (result) {
                _this.submissionCompleted();
            }, function (error) {
                _this.confirmLoading = false;
                _this.getErrorMessage(error);
            });
        }
        return;
    };
    DocumentApprovalPreviewComponent.prototype.rejectTaxData = function () {
        this.action = 'reject';
        this.modal = this.modalService.open(this.rejectModal, {
            backdrop: 'static',
            size: 'lg'
        });
    };
    DocumentApprovalPreviewComponent.prototype.approveTaxData = function () {
        this.action = 'approve';
        this.modal = this.modalService.open(this.approveModal, {
            backdrop: 'static',
            centered: true
        });
    };
    DocumentApprovalPreviewComponent.prototype.getTaxData = function () {
        var _this = this;
        this.isLoading = true;
        this.customerApiService.getTaxData(this.document).subscribe(function (result) {
            _this.haveTaxData = true;
            _this.isLoading = false;
            _this.pdf = {
                url: result.pdf_file,
                withCredentials: false,
            };
            _this.customerForm = _this.formBuilder.group({
                address: [result.address],
                branchCode: [result.branch_code],
                branchName: [result.branch_name],
                ccEmail: [result.cc_email],
                countryCode: [result.country_code],
                email: [result.email],
                name: [result.name],
                postCode: [result.post_code],
                taxID: [result.tax_id],
                remark: [null],
                contact: [null]
            });
        }, function (error) {
            _this.isLoading = false;
            _this.haveTaxData = false;
            _this.getErrorMessage(error);
        });
    };
    DocumentApprovalPreviewComponent.prototype.setPDF = function (pdf) {
        this.pdfPageLength = pdf.numPages;
        this.pdfLoaded = true;
    };
    DocumentApprovalPreviewComponent.prototype.resetPDF = function () {
        this.pdfLoaded = false;
        this.pdfPage = 1;
        this.pdfError = undefined;
    };
    DocumentApprovalPreviewComponent.prototype.nextPage = function () {
        if (this.pdfPage < this.pdfPageLength) {
            this.pdfPage++;
        }
    };
    DocumentApprovalPreviewComponent.prototype.prevPage = function () {
        if (this.pdfPage > 1) {
            this.pdfPage--;
        }
    };
    return DocumentApprovalPreviewComponent;
}());
export { DocumentApprovalPreviewComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/document-approval/document-approval-preview/document-approval-preview.component.ts.pre-build-optimizer.js